module.exports = __webpack_public_path__ + "media/images/staff-new-5f7b7757.svg";